import { EstadosProcesoEnumChoice, gridSize, gridSizeMdLg4, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchOrdenesCompras } from "@/shared/actions/erp";
import { CustomAutocomplete, GeneralTable } from "@/shared/components/ui";
import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface";
import { Grid } from "@mui/material";
import useTableOrdenesCompraFinalizado from "../hook/useTableOrdenesCompraFinalizado";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import ActionsBar from "@/shared/components/ui/ActionBar";

import { useForm } from "react-hook-form";
import { AlertSeverityEnum, Ingreso_inventario } from "@/shared/interfaces";
import { useFileDowloadDoc } from "@/shared/hooks/useDownloadFileDoc";
import { useUiStore } from "@/store/ui";
import { useFilePrint } from "@/shared/hooks/usePrintFile";
import { useEffect } from "react";
import ModalObservacionNoForm from "@/shared/components/ui/ModalObservacionNoForm";


export const RecepcionCompraFinalizadoPage = () => {
  ///****************STORE
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationTabla = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const setAlert = useUiStore(s => s.setAlert)

  ///****************HOOK
  const { infoOrdenFinalizado, isOpenModal, setIsOpenModal, detailsProducts, isOpenModal2,
    setIsOpenModal2, infoIngresoInventario, readProducts, urlPdf, setProductos, setReadProducts,
    observacionCerrarOrden
  } = useTableOrdenesCompraFinalizado()
 
  const { pagination, setPagination } = useTableFilter()
  const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering()
  const form = useForm<Ingreso_inventario>({})
  const { control, formState: { errors } } = form
  const { downloadFile } = useFileDowloadDoc()
  const { printFile } = useFilePrint()

  const { pageIndex, pageSize } = pagination
  ///****************_FETCH_*****///
  const { data: dataOrdenFinalizado, isLoading: isLoadingOrdenFinalizado } = useFetchOrdenesCompras({
    page: pageIndex + 1,
    page_size: pageSize,
    estado_orden: EstadosProcesoEnumChoice.FINALIZADO,
    ...filterObject,
    filterByState: false

  })
  //************************** dowload
  const handleDowload = async () => {
    const { url_pdf } = form.getValues()

    if (!url_pdf) return setAlert(true, 'Seleccione un número de ingreso para habilitar la descarga.', AlertSeverityEnum.error)

    downloadFile({
      url: url_pdf,
      nameFile: 'ingreso_Inventario',
      extensionFile: 'pdf'
    })
  }
  //************************** print
  const handlePrint = async () => {
    const { url_pdf } = form.getValues()
    if (!url_pdf) return setAlert(true, 'Seleccione un número de ingreso para habilitar la impresión.', AlertSeverityEnum.error)
    printFile({ urlPdf: url_pdf! })
  }
  //**************************useEffect clear */
  useEffect(() => {
    if (!isOpenModal) {
      setProductos([])
      setReadProducts([]) ///ojo con esto solo se limpia cuando cierro todo el modal
    }
  }, [isOpenModal])

  const pdfDisponible = urlPdf.some(item => !!item.url_pdf)

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable<OrdenesCompra>
            columns={infoOrdenFinalizado}
            data={dataOrdenFinalizado?.data.data || []}
            isLoading={isLoadingOrdenFinalizado}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataOrdenFinalizado?.data.count}
            canEdit={false}
            enableEditing={false}
            //filterServer
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
          />
        </Grid>
      </Grid>
      <ScrollableDialogProps
        open={isOpenModal}
        onCloseIcon={() => { form.setValue('url_pdf', ''), setIsOpenModal(false), clearSelectedItems() }}
        title="📋 Detalles de Productos Finalizadas"
        minWidth="80%"
        minHeight="80%"
        contentNode={
          <>
            <Grid container spacing={2}>
              <Grid item {...gridSize}>
                <Grid container spacing={2} justifyContent={'flex-end'}>
                  <Grid item {...gridSizeMdLg4}>
                    <CustomAutocomplete
                      label="Seleccione un reporte PDF"
                      name="url_pdf"
                      options={urlPdf}
                      isLoadingData={false}
                      valueKey={"reporte_nombre"}
                      actualValueKey={"url_pdf"}
                      defaultValue={undefined}
                      control={control}
                      error={errors.url_pdf}
                      helperText={errors.url_pdf?.message}
                      disabled={!pdfDisponible}
                    /*  onChangeValue={(e) => {
                        console.log('e', e)
                      }} */
                    />
                  </Grid>
                  <Grid item >
                    <ActionsBar
                      disabled={!pdfDisponible}
                      onDownload={handleDowload}
                      onPrint={handlePrint}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <ModalObservacionNoForm
                label="Observación de cierre"
                texto={observacionCerrarOrden || 'N/A'}
                size={gridSizeMdLg4}
                title="Observación"
                numbertextPreview={20}
              />

              <Grid item {...gridSize}>
                <SampleTablePagination
                  columns={detailsProducts}
                  data={paginatedData}
                  pagination={paginationTabla}
                  setPagination={setPaginationTable}
                  rowCount={productos.length}
                  rowNumber={true}
                />
              </Grid>


            </Grid>

          </>
        }
      />
      <ScrollableDialogProps
        open={isOpenModal2}
        onCloseIcon={() => { setIsOpenModal2(false) }}
        title="Información"
        minWidth="60%"
        minHeight="60%"
        contentNode={
          <>

            <SampleTablePagination
              columns={infoIngresoInventario}
              data={readProducts}
              pagination={paginationTabla}
              setPagination={setPaginationTable}
              rowCount={readProducts.length}
              rowNumber={true}
            />
          </>
        }
      />
    </>
  )
}
export default RecepcionCompraFinalizadoPage;